var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Projeto_ColaboradorActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Projeto_ColaboradorModule = class Projeto_ColaboradorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Projeto_ColaboradorActions.POST_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Projeto_Colaborador/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Projeto_ColaboradorActions.PUT_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.put("Projeto_Colaborador/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Projeto_ColaboradorActions.DELETE_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Projeto_Colaborador/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Projeto_ColaboradorActions.DELETE_RANGE_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Projeto_Colaborador/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Projeto_ColaboradorActions.FILTER_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Projeto_Colaborador/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Projeto_ColaboradorActions.GET_PROJETO_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Projeto_ColaboradorActions.GETWITHDISABLED_PROJETO_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Projeto_ColaboradorActions.GET_BY_ID_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Projeto_ColaboradorActions.GET_BY_ID_PROJETO_PROJETO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetByIdProjeto", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Projeto_ColaboradorActions.GETPROJETOCOLABORADOR_PROJETO_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetProjetoColaborador")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = Projeto_ColaboradorActions.GETPROJETOCOLABORADOR_BY_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetProjetoColaboradorByColaborador", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = Projeto_ColaboradorActions.GET_PROJETO_COLABORADOR_DIARIAS]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Colaborador/GetProjetoColaboradorDiarias")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ColaboradorModule.prototype, _m, null);
Projeto_ColaboradorModule = __decorate([
    Module
], Projeto_ColaboradorModule);
export default Projeto_ColaboradorModule;
//# sourceMappingURL=Projeto_ColaboradorModule.js.map